import { render, staticRenderFns } from "./tabUsCustomsClearanceMasterItem.vue?vue&type=template&id=1ea76c7c&scoped=true&"
import script from "./tabUsCustomsClearanceMasterItem.vue?vue&type=script&lang=js&"
export * from "./tabUsCustomsClearanceMasterItem.vue?vue&type=script&lang=js&"
import style0 from "./tabUsCustomsClearanceMasterItem.vue?vue&type=style&index=0&id=1ea76c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea76c7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea76c7c')) {
      api.createRecord('1ea76c7c', component.options)
    } else {
      api.reload('1ea76c7c', component.options)
    }
    module.hot.accept("./tabUsCustomsClearanceMasterItem.vue?vue&type=template&id=1ea76c7c&scoped=true&", function () {
      api.rerender('1ea76c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceMasterItem.vue"
export default component.exports